/* eslint-disable sonarjs/no-duplicate-string, react/jsx-props-no-spreading */
import { Box, Tab, TabProps, Tabs, TabsProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { faLockKeyhole } from "@fortawesome/pro-light-svg-icons";

import { FontAwesomeSvgIcon } from "./FontAwesomeSvgIcon";

const LockIcon = () => {
  return (
    <Box
      data-testid="tab-lock-icon"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginBottom: "0px !important",
        py: 0.5,
      }}
    >
      <FontAwesomeSvgIcon icon={faLockKeyhole} sx={{ fontSize: 13 }} />
    </Box>
  );
};

type UtfTabProps = {
  isLocked?: boolean;
} & TabProps;

export function UtfTab({ isLocked = false, icon, ...props }: UtfTabProps) {
  return (
    <Tab
      disableRipple
      data-testid={`tab-${props.value}`}
      {...props}
      icon={
        isLocked ? (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <LockIcon />
          </Box>
        ) : (
          icon
        )
      }
      iconPosition="start"
    />
  );
}

// `props` must be annotated: under JSS it fell back to implicit `any`, but emotion
// infers the wrapper's props and would otherwise narrow UtfTabs to accept nothing.
export const UtfTabs = styled((props: TabsProps) => <Tabs {...props} />)(
  () => ({
    minHeight: 40,
  }),
  { name: "UtfTabs" }
);
